import { render } from "./HeroiconsOutlineSparkles.vue?vue&type=template&id=24e9c082"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSparkles.vue"]])

export default __exports__